/** Keep support actionable, including fixed server error messages. */
export function SupportMessage({ text }: { text: string }) {
  return <>{text.split(/(contact support)/gi).map((part, i) => /^contact support$/i.test(part)
    ? <a key={i} href="mailto:partners@evinitiative.com">{part} at partners@evinitiative.com</a>
    : part)}</>;
}
